import React, { useState, useEffect } from 'react';
import api from '../services/api';

const TitleNotesModal = ({ vehicle, isOpen, onClose, onUpdate, module = 'titles' }) => {
  const [notes, setNotes] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isOpen && vehicle) {
      if (module === 'transport') {
        setNotes(vehicle.transportNotes || '');
      } else {
        setNotes(vehicle.titleNotes || '');
      }
    }
  }, [isOpen, vehicle, module]);

  const handleSave = async () => {
    if (!vehicle) return;
    
    setSaving(true);
    try {
      const updateData = module === 'transport' 
        ? { transportNotes: notes }
        : { titleNotes: notes };
      
      await api.updateVehicle(vehicle.id, updateData);
      
      if (onUpdate) {
        const updatedVehicle = module === 'transport'
          ? { ...vehicle, transportNotes: notes }
          : { ...vehicle, titleNotes: notes };
        onUpdate(updatedVehicle);
      }
      onClose();
    } catch (error) {
      alert('Failed to save notes: ' + error.message);
    } finally {
      setSaving(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">
            {module === 'transport' ? 'Transport Notes' : 'Title Notes'}
          </h3>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            ✕
          </button>
        </div>
        
        {vehicle && (
          <div className="mb-4">
            <div className="text-sm text-gray-600 mb-2">
              <strong>{vehicle.year} {vehicle.make} {vehicle.model}</strong>
            </div>
            <div className="text-xs text-gray-500">
              Stock: {vehicle.stockNumber} • Status: {module === 'transport' ? vehicle.transportStatus : vehicle.titleStatus}
            </div>
          </div>
        )}

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {module === 'transport' ? 'Transport Notes' : 'Title Notes'}
          </label>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows={6}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder={module === 'transport' ? 'Add notes about transport status, vendor, delivery, etc...' : 'Add notes about title status, issues, or updates...'}
          />
        </div>

        <div className="flex gap-2 justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 border border-gray-300 rounded hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={saving}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
          >
            {saving ? 'Saving...' : 'Save Notes'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TitleNotesModal;
